import type { RankConfig, RankData, RankDataParams } from '@/types/rank'
import BaseService from '../../BaseService'
import type { CustomAxiosResponse } from '../../types'

class RankService extends BaseService {
  /**
   * 获取游戏排行配置
   * @param gameId 游戏ID
   * @returns 游戏排行配置
   */
  public async getRankConfigByGameId(gameId: string): Promise<CustomAxiosResponse<RankConfig[]>> {
    return this.request.get<unknown, CustomAxiosResponse<RankConfig[]>>(`${this.apiUrl}/v1/game/app/rank/config`, {
      params: {
        gameId
      }
    })
  }

  /**
   * 获取游戏排行数据
   * @param rankId 排行榜ID
   * @returns 游戏排行数据
   */
  public async getRankData(rankId: string): Promise<CustomAxiosResponse<RankData>> {
    return this.request.get<unknown, CustomAxiosResponse<RankData>>(`${this.apiUrl}/v1/game/app/rank/data`, {
      params: {
        rankId
      }
    })
  }

  /**
   * 上报排行榜数据
   * @param options 排行榜数据
   * @returns null
   */
  public async reportankData(options: RankDataParams): Promise<CustomAxiosResponse<null>> {
    return this.request.post<unknown, CustomAxiosResponse<null>>(`${this.apiUrl}/v1/game/app/rank/data`, {
      ...options
    })
  }
}

export default RankService
